import styled from 'styled-components';

import { SelectColor } from '../../../../services/reports';

export const StyledGenderOrAgesPerformance = styled.div`
  margin-top: 30px;
  
  .content-1200 {
  	margin: 0 auto;
  	padding: 0 40px;
  }
  
  @media screen and (max-width: 850px) {
    width: 100%;
    
    .content-charts {
      margin: 0 auto;
    }
  }

  section {
    padding: 0 40px;
    
    h2 {
      font-family: Poppins-Medium, Heltica, Arial, sans-serif;
      font-size: 15px;
      color: #2B2932;
      margin: 0 0 10px 0;
    }
    
    p {
      font-family: Poppins, Heltica, Arial, sans-serif;
      font-size: 14px;
      line-height: 1.5em;
      color: #2B2932;
      margin: 0;
    }
  }
  
  hr {
  	margin: 30px 0 !important;
    border-color: #F5F7F9;
  }
  
  .content-charts {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 30px;
    
    @media screen and (max-width: 850px) {
      flex-direction: column;
      height: 100%;
    }
    
    .bar-chart svg {
      font-size: 14px !important;
    }
  }
  
  .legend {
    display: flex;
    align-items: center;
    font-family: Poppins, Heltica, Arial, sans-serif;
    color: #707070;
    font-size: 14px;
    margin: 0 40px;
    
    &.legend-simple {
      transform: translateY(-25px);
      margin: 0 25px;
    }
    
    div:first-child {
      margin-right: 15px;
    }
    
    .topic-1,
    .topic-2 {
      &:before {
        content: '';
        width: 15px;
        height: 15px;
        display: inline-block;
        vertical-align: middle;
        margin-right: 5px;
        border-radius: 2px;
      }
    }
    
    .topic-1:before {
      background-color: ${props => SelectColor(props.channel, 'clicks')};
    }
    
    .topic-2:before {
      background-color: ${props => SelectColor(props.channel, 'impressions')};
    }
  }
`;
